import { render, staticRenderFns } from "./OverlayMediaPicker.vue?vue&type=template&id=78937210&"
import script from "./OverlayMediaPicker.vue?vue&type=script&lang=js&"
export * from "./OverlayMediaPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports